import ConnectedClassUnderReviewPage from './ClassUnderReviewPage';

export default ConnectedClassUnderReviewPage;
